import { render, staticRenderFns } from "./pricingTwo.vue?vue&type=template&id=1cf4d3cc&"
import script from "./pricingTwo.vue?vue&type=script&lang=js&"
export * from "./pricingTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports